import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ChevronRight } from "lucide-react";
import { useTheme } from "../../context/ThemeContext";
import { ThemedShell } from "../../components/child/ThemedShell";
import { Button } from "../../components/ui/button";

const GAMES = [
  { id: "dinorace", emoji: "🦖", to: "/leerling/dinorace", title: "Dinorace", desc: "Spring over cactussen in een head-to-head race — tegen de computer of een vriend!", border: "var(--t-primary)" },
  { id: "digger", emoji: "🚜", to: "/leerling/digger", title: "Digger", desc: "Graaf tunnels, verzamel smaragden 💎 en ontwijk de aliens. Haal alle 10 levels!", border: "var(--t-primary)" },
  { id: "catz", emoji: "💨", to: "/leerling/alley", title: "Catz Fart Attack!", desc: "Klim via de waslijnen naar het open raam — scheet jezelf omhoog 💨 en eet alle brokjes vóór de bulldog wakker wordt! 🐶", border: "var(--t-accent)" },
  { id: "codekraker", emoji: "🎨", to: "/leerling/codekraker", title: "Codekraker", desc: "Kraak de geheime kleurcode — solo of daag een vriend uit.", border: "var(--t-accent)" },
  { id: "vogelvlucht", emoji: "🐤", to: "/leerling/vogelvlucht", title: "Vogelvlucht", desc: "Fladder door de buizen! Speel tegen de computer of een vriend.", border: "var(--t-accent)" },
  { id: "knikkerrace", emoji: "🏎️", to: "/leerling/race", title: "Knikkerrace", desc: "Verzamel race-tickets en kijk welke knikker wint!", border: "var(--t-accent)" },
];

export default function Speelhoek() {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const muted = { color: "var(--t-muted)" };

  return (
    <ThemedShell>
      <div className="max-w-2xl mx-auto px-5 pt-8 pb-16">
        <div className="flex items-center gap-2 mb-2">
          <Button variant="ghost" onClick={() => navigate("/leerling")} className="rounded-full px-3" style={{ color: "var(--t-text)" }} data-testid="speelhoek-back"><ArrowLeft className="w-5 h-5" /></Button>
          <h1 className="font-heading text-3xl font-black themed-heading">Speelhoek 🕹️</h1>
        </div>
        <p className="font-semibold mb-7 ml-1" style={muted}>Kies een spel en speel — solo of samen met een vriend!</p>

        <div className="grid gap-4">
          {GAMES.map((g, i) => (
            <motion.button key={g.id} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.07 }}
              onClick={() => navigate(g.to)} data-testid={`speelhoek-${g.id}`}
              className="w-full rounded-3xl p-5 flex items-center gap-4 border-2 hover:-translate-y-1 active:scale-[0.99] transition-all text-left"
              style={{ background: "var(--t-surface)", borderColor: g.border }}>
              <div className="w-16 h-16 rounded-2xl flex items-center justify-center text-4xl shrink-0" style={{ background: "var(--t-surface2)" }}>{g.emoji}</div>
              <div className="flex-1">
                <h3 className="font-heading text-xl font-extrabold themed-heading">{g.title}</h3>
                <p className="text-sm font-semibold" style={muted}>{g.desc}</p>
              </div>
              <ChevronRight className="w-6 h-6" style={{ color: g.border }} />
            </motion.button>
          ))}
        </div>

        <p className="text-center text-sm font-semibold mt-8" style={muted}>{theme.mascot} Meer spellen komen eraan!</p>
      </div>
    </ThemedShell>
  );
}
